module.exports = __webpack_public_path__ + "static/media/positividade.aa271699.jpg";